import { Formik } from "formik";
import { useState } from "react";
import { ValidationsForms } from "../../../../Constant";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { VALIDATION_FORM, VALIDATION_INITIALVALUE, VALIDATION_VALIDATIONSCHEMA } from "../../../../Data/FormControl/FormValidation";
import { FormValidationProp } from "../../../../Type/FormValidation";
import { FormValidations } from "./FormValidations";

const ValidationForm = () => {
  const [submitErrors, setSubmitError] = useState<boolean>(false);

  const handleSubmit = (values: FormValidationProp, { resetForm }: { resetForm: () => void }) => {
    resetForm();
    setSubmitError(false);
  };

  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={ValidationsForms} span={VALIDATION_FORM} />
        <CardBody>
          <Formik initialValues={VALIDATION_INITIALVALUE} onSubmit={handleSubmit} validationSchema={VALIDATION_VALIDATIONSCHEMA}>
            {({ errors }) => <FormValidations submitErrors={submitErrors} setSubmitError={setSubmitError} errors={errors} />}
          </Formik>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ValidationForm;
